/**
 * Tag normalization utilities — shared between server and client.
 *
 * Rules (applied in order):
 *  1. Trim whitespace
 *  2. Lowercase
 *  3. Replace spaces with hyphens
 *  4. Strip all chars except a-z, 0-9, -, _
 *  5. Collapse consecutive - or _ to one
 *  6. Trim leading/trailing - and _
 *  7. Truncate to 50 chars
 *  8. Empty result → returns ''
 */

/**
 * Normalize a single raw tag string.
 * Returns an empty string if the input has no valid characters after normalization.
 */
export function normalizeTag(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9_-]/g, '')
    .replace(/[-_]{2,}/g, (s) => s.charAt(0) || '-')
    .replace(/^[-_]+|[-_]+$/g, '')
    .slice(0, 50);
}

/**
 * Normalize an array of raw tag strings.
 * Empty results and duplicates (post-normalization) are silently dropped.
 */
export function normalizeTags(raw: string[]): string[] {
  return [...new Set(raw.map(normalizeTag).filter((t) => t.length > 0))];
}
